import React, { useState, useEffect } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import moment from 'moment';

import SelfPDFViewer from '../../../../components/PDFViewer';

import { GET, newFetch } from '../../../../helpers/fetch';

import { config } from '../../../../config/index';

import placeholderImage from '../../../../assets/images/placeholder.jpg';

const { SERVER_URL } = config;

const blobToFile = (theBlob, fileName) => {
  //A Blob() is almost a File() - it's just missing the two properties below which we will add
  theBlob.lastModifiedDate = new Date();
  theBlob.name = fileName;
  return theBlob;
};

const InstructionDetail = ({
  history,
  match: {
    params: { instruction_id },
  },
}) => {
  const [instruction, setInstruction] = useState(null);

  const fetchInstruction = async () => {
    let api_path = `/communication/${instruction_id}`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      setInstruction(response.data);
    }
  };

  useEffect(() => {
    fetchInstruction();
  }, []);

  return (
    <React.Fragment>
      <div style={{ paddingTop: '3rem', marginBottom: '6rem' }}>
        <div
          className="d-flex flex-column"
          style={{ paddingLeft: '3rem', paddingRight: '3rem' }}
        >
          <NavLink
            to="/communication"
            className="text-decoration-none"
            style={{ color: 'inherit' }}
          >
            <div style={{ color: '#5156BE' }}>
              <i className="fas fa-chevron-left pe-2"></i>Back to Communication
            </div>
          </NavLink>
          <div className="d-flex justify-content-between pt-4">
            <h5>
              Instruction ID: {instruction ? instruction.communication_id : ''}
            </h5>
          </div>
        </div>
        <div
          className="d-flex"
          style={{ marginTop: '2rem', marginLeft: '3rem', marginRight: '3rem' }}
        >
          <div className="flex-grow-1">
            <div className="rounded shadow bg-white">
              {instruction && (
                <div className="p-4 d-flex flex-column">
                  <h6 style={{ wordBreak: 'break-all' }}>
                    {instruction.title}
                  </h6>
                  <div className="pt-2" style={{ whiteSpace: 'pre-line' }}>
                    {instruction.description}
                  </div>
                  {instruction.uploads.length > 0 ? (
                    <div className="pt-4">Attached File(s)</div>
                  ) : null}
                  <div className="pt-3">
                    <div className="row" style={{ maxWidth: '100%' }}>
                      {instruction.uploads &&
                        instruction.uploads.length > 0 &&
                        instruction.uploads.map((upload) => (
                          <div
                            key={upload.id}
                            className="col-3"
                            style={{ marginBottom: '30px' }}
                          >
                            <div
                              className="p-3 h-100 border rounded"
                              onClick={() =>
                                window.open(
                                  `${SERVER_URL}/${upload.url}`,
                                  '_blank'
                                )
                              }
                              style={{ cursor: 'pointer' }}
                            >
                              {upload.url.split('.').pop().toLowerCase() ===
                                'jpg' ||
                              upload.url.split('.').pop().toLowerCase() ===
                                'jpeg' ||
                              upload.url.split('.').pop().toLowerCase() ===
                                'png' ? (
                                <img
                                  src={`${SERVER_URL}/${upload.url}`}
                                  alt=""
                                  style={{ width: '100%' }}
                                />
                              ) : upload.url.split('.').pop().toLowerCase() ===
                                'pdf' ? (
                                <SelfPDFViewer
                                  file={`${SERVER_URL}/${upload.url}`}
                                  withPageNum={false}
                                />
                              ) : (
                                ''
                              )}
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          {instruction && (
            <div
              className="d-flex flex-column"
              style={{ minWidth: '250px', width: '250px', marginLeft: '2rem' }}
            >
              <strong>Date Created</strong>
              <div className="mt-2">
                {moment(instruction.createdAt).format('DD MMMM YYYY')}
              </div>

              <strong className="mt-4">Created by</strong>
              <div
                className="d-flex align-items-center my-1 py-1 mt-2 rounded"
                style={{ backgroundColor: '#f1f1f1' }}
              >
                <div className="mx-2">
                  <img
                    className="img-responsive rounded-circle border"
                    src={
                      instruction.admin.image
                        ? `${SERVER_URL}/${instruction.admin.image}`
                        : placeholderImage
                    }
                    alt="username-img"
                    style={{ height: '35px', width: '35px' }}
                  />
                </div>
                <div className="d-flex justify-content-between align-items-center w-100">
                  <div>
                    {`${instruction.admin.first_name} ${instruction.admin.last_name}`
                      .length > 18
                      ? `${instruction.admin.first_name} ${instruction.admin.last_name}`.substr(
                          0,
                          18
                        ) + '...'
                      : `${instruction.admin.first_name} ${instruction.admin.last_name}`}
                  </div>
                </div>
              </div>

              <strong className="mt-4 mb-2">Receipients(s)</strong>
              {instruction &&
                instruction.associates.length > 0 &&
                instruction.associates.map((associate) => (
                  <div
                    key={associate.id}
                    className="d-flex align-items-center my-1 py-1 rounded"
                    style={{ backgroundColor: '#f1f1f1' }}
                  >
                    <div className="mx-2">
                      <img
                        className="img-responsive rounded-circle border"
                        src={
                          associate.image
                            ? `${SERVER_URL}/${associate.image}`
                            : placeholderImage
                        }
                        alt="username-img"
                        style={{ height: '35px', width: '35px' }}
                      />
                    </div>
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <div>
                        {`${associate.first_name} ${associate.last_name}`
                          .length > 18
                          ? `${associate.first_name} ${associate.last_name}`.substr(
                              0,
                              18
                            ) + '...'
                          : `${associate.first_name} ${associate.last_name}`}
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default withRouter(InstructionDetail);
